import React from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import TextRenderer from './../TextRenderer'
import Image from './../Image'

import styles from './styles.module.scss'

const Quote = (props) => {
    
    const headingClasses = cx({
        [styles['quote__heading']]: true,
        [styles['quote__heading--center']]: props.blok.text_align == 'center',
    })

    const quoteClasses = cx({
        [styles['quote']]: true,
        [styles['quote--minimal']]: props.blok.minimize_spacing
    })

	return (
		<SbEditable content={props.blok}>
			<section className={quoteClasses} style={{ backgroundColor: props.blok.background_color || '#fff' }}>
                {props.blok.vertical_title && <span className={'section-title'}>{props.blok.title}</span>}
                <div className={`container ${styles['quote__container']}`}>
                    <TextRenderer text={props.blok.copy} className={headingClasses} style={{ textAlign: props.blok.text_align }} />
                </div>
                {props.blok.background_image && props.blok.background_image.filename && <Image image={props.blok.background_image} blok={props.blok} className={styles['quote__background-image']} params={{ maxWidth: 1280 }} />}
            </section>
		</SbEditable>
	)
}

export default Quote
